import React from 'react'
import { Container, Row, Col ,Image} from "react-bootstrap";
import BreadCrumb from '../components/BreadCrumb';
import { FaEye, FaBullseye,FaHeart } from 'react-icons/fa';
const Managersmsg = ({ show = true }) => {
    return (
      <>
        {show && <BreadCrumb pagename={'Managers Message'} />}
        <section className="ftco-section ftco-no-pt ftc-no-pb">
          <Container className='mt-16 mb-6'>
            
            <Row style={{ marginLeft: '40px', marginRight: '40px', fontSize: '1rem' }}>
              
              <Col md={7} className="wrap-about py-5 p-2 pr-md-4 ftco-animate">
              <h3 className="mb-4 font-bold">From the bottom of heart....</h3>
              <h5 className="mb-4 font-bold">Welcome to Mount Thabore Central School, </h5>
              
                <p style={{textAlign:'left'}} >
                we are committed to providing a nurturing environment that fosters academic excellence, creativity, and character development.


                </p>
               <div className="principal-info mt-3">
                    <p style={{textAlign:'left'}}>
                      We look forward to working together to achieve excellence and make a positive impact on the lives of our students.<br></br>
                        Thank you for choosing Mount Thabore Central School<br></br>

                                Sincerely,<br></br>
                                Manager,<br></br>
                                Mount Thabore Central School<br></br>
                                Peechanikkad
                                </p>
                        </div>
               
                </Col>

              <Col md={5} className="text-center">
                        <Image
                          src="./image/management/manager1.jpg"
                          alt="Principal"
                          fluid
                          rounded
                          style={{
                              width: '490px',
                              height: '300px',
                              objectFit: 'cover',
                              objectPosition: '50% 22%',
                              marginTop:'20px'
                            }}
                        />
                        <div className="principal-info mt-3">
                          <h5 className="principal-name">Fr. Alias Ipe Parackal</h5>
                          <p className="principal-designation">Manager</p>
                          </div>
                          
                 </Col>
                 <Col>
                 
                      </Col>
                      </Row>
                      <Row>
             
              
                <Col lg={6}>
                    <div className="services-2 d-flex">
                     
                       <div className="icon-container-about">
                        
                        <FaEye size={30} style={{ color: '#2b6cb0' }} />
                      </div> 
                      <div className="text">
                        <h3>Our Vision</h3>
                        <p style={{textAlign:'left'}}>
                        We strive to empower students with knowledge, skills, and values necessary to succeed in an ever-changing world.<br/> Our dedicated faculty and staff work tirelessly to ensure a supportive and inclusive learning environment..
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="services-2 d-flex">
                     <div className="icon-container-about">
                        
                         <FaBullseye size={30} style={{ color: '#38a169' }} />
                      </div> 
                      <div className="text">
                        <h3>Our Mission
                        </h3>
                        <p style={{textAlign:'left'}}>
                        - To deliver high-quality education that meets the needs of all students<br/>
                        - To promote holistic development through extracurricular activities and community service<br/>
                        - To build strong relationships with parents, students, and staff

                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="services-2 d-flex">
                       <div className="icon-container-about">
                       <FaHeart size={32} style={{ color: '#38a169' }}/>
                       
                      </div> 
                      <div className="text">
                        <h3>We Value:
                        </h3>
                        <p style={{textAlign:'left'}}>
                        - Academic achievement and intellectual curiosity<br/>
                        - Creativity, innovation, and critical thinking <br/>
                        - Emotional intelligence, empathy, and social responsibility

                        </p>
                      </div>
                    </div>
                  </Col> 
              
            </Row>
          </Container>
        </section>
        
      </>
    );
  };

export default Managersmsg